function addSlider($el, number) {
    var reallyNumber = $el.find('.swiper-slide').length;
    var surplusNumber = reallyNumber % number;
  
    if (surplusNumber == 0) {
      return;
    }
  
    for (var i = 0; i < number - surplusNumber; i++) {
      $el.find('.swiper-wrapper').append($el.find('.swiper-slide').eq(0).clone().addClass('no-bg').html(''));
    }
}
  
window.addSlider = addSlider;


function addSpanSearch(keyword, searchClass, spanClass) {
   keyword = String(keyword).trim();
   if (!keyword) {
      return false;
   }
   $(searchClass).each(function () {
      var $dom = $(this);
      let regString = /(\$|\^|\*|\\|\+|\?|\.)/gi;
      let oldKeyWord = keyword;
      keyword = keyword.replace(regString, '\\'+ '$1');
      let reg = new RegExp('(' + keyword + ')', 'g');
      if ($dom.text().indexOf(oldKeyWord) !== -1) {
         $dom.children().each(function () {
            $(this)
               .find('[data-highlight]')
               .each(function () {
                   var newHtml = $(this)
                      .text()
                      .replace(reg, '<span class="' + spanClass + '">$1</span>');
                   $(this).html(newHtml);
               });
         });
      }
   });
}

window.addSpanSearch = addSpanSearch;

function imgGallery() {
   $('.img-gallery').each(function(index, item){
       let $el = $(item);
       let childTagName = '';
       try{
       childTagName = $el.children().first().get(0).tagName;
       }catch(e){
       }
       if(childTagName){

           $el.magnificPopup({
               delegate: childTagName,
               type: 'image',
               closeOnContentClick: false,
               closeBtnInside: false,
               mainClass: 'mfp-with-zoom mfp-img-mobile',
               image: {
                   verticalFit: true,
                   titleSrc: function(item) {
                       return $(item.el[0]).data('title');
                   }
               },
               gallery: {
                   enabled: true
               },
               zoom: {
                   enabled: true,
                   duration: 300, // don't foget to change the duration also in CSS
                   opener: function(element) {
                       return element.find('img');
                   }
               }
           })
       }
   });
}

window.imgGallery = imgGallery;


jQuery.msgBox = msg;
function msg (options) {
    var isShown = false;
    var typeOfValue = typeof options;
    var defaults = {
        title: options.title || "提示",
        autoClose: false,
        timeOut: 0,
        modal: false,
        showButtons: true,
        buttons: [{ value: "确定", className: 'confirm'}],
        success: function (result) { },
        beforeShow: function () { },
        afterShow: function () { },
        beforeClose: function () { },
        afterClose: function () { },
        opacity: 0.5
    };
    options = typeOfValue == "string" ? defaults : options;

    options.timeOut = options.timeOut == null ? (options.content == null ? 500 : options.content.length * 70) : options.timeOut;
    options = $.extend({}, defaults, options);
    if (options.autoClose) {
        setTimeout(hide, options.timeOut);
    }

    var divId = "msgBox" + new Date().getTime();

    /* i was testing with ($.browser.msie  && parseInt($.browser.version, 10) === 7) but $.browser.msie is not working with jQuery 1.9.0 :S. Alternative method: */
    if ( navigator.userAgent.match(/msie 7/i) !== null) { var divMsgBoxContentClass = "msgBoxContentIEOld"; } else { var divMsgBoxContentClass = "content-msg";}

    var divMsgBoxId = divId;
    var divMsgBoxContentId = divId+"Content";
    var divMsgBoxButtonsId = divId+"Buttons";
    var divMsgBoxBackGroundId = divId+"BackGround";
    var firstButtonId = divId+"FirstButton";

    var buttons = "";
    var isFirstButton = true;
    $(options.buttons).each(function (index, button) {
        var add = "";
        if (isFirstButton) {
            add = ' id="' + firstButtonId + '"';
            isFirstButton = false;
        }
        buttons += "<a class=\"btn " + button?.className +" \" " + add + ">" + button.value + "</div>";
    });

    var divBackGround = "<div id=\"" + divMsgBoxBackGroundId + "\" class=\"msgBoxBackGround\"></div>";
    var divTitle = "<div class=\"title\">" + options.title + "</div>";
    var divContainer = "<div class=\"msgBoxContainer\"><div id=\"" + divMsgBoxContentId + "\" class=\"" + divMsgBoxContentClass + "\"><p><span>" + options.content + "</span></p></div></div>";
    var divButtons = "<div id=\"" + divMsgBoxButtonsId + "\" class=\"msgBoxButtons\">" + buttons + "</div>";

    var divMsgBox;
    var divMsgBoxContent;
    var divMsgBoxButtons;
    var divMsgBoxBackGround;

    $("body").append(divBackGround + "<div id=\"" + divMsgBoxId + "\" class=\"msg-box no-mt\">" + divTitle + "<div class=\"content\">" + divContainer + (options.showButtons ? divButtons + "</div>" : "</div>") + "</div>");
    divMsgBox = $("#"+divMsgBoxId);
    divMsgBoxContent = $("#"+divMsgBoxContentId);
    divMsgBoxButtons = $("#"+divMsgBoxButtonsId);
    divMsgBoxBackGround = $("#"+divMsgBoxBackGroundId);

    var width = divMsgBox.width();
    var height = divMsgBox.height();
    var windowHeight = $(window).height();
    var windowWidth = $(window).width();

    var top = windowHeight / 2 - height / 2;
    var left = windowWidth / 2 - width / 2;

    show();

    function show() {
        if (isShown) {
            return;
        }
        divMsgBox.css({ opacity: 0, top: top - 50, left: left });
        divMsgBoxBackGround.css({ opacity: options.opacity });
        options.beforeShow();
        divMsgBoxBackGround.css({ "width": $(document).width(), "height": getDocHeight() });
        $(divMsgBoxId+","+divMsgBoxBackGroundId).fadeIn(0);
        divMsgBox.animate({ opacity: 1, "top": top, "left": left }, 200);
        setTimeout(options.afterShow, 200);
        $("#" + firstButtonId).focus();
        isShown = true;
        $(window).bind("resize", function (e) {
            var width = divMsgBox.width();
            var height = divMsgBox.height();
            var windowHeight = $(window).height();
            var windowWidth = $(window).width();

            var top = windowHeight / 2 - height / 2;
            var left = windowWidth / 2 - width / 2;

            divMsgBox.css({ "top": top, "left": left });
            divMsgBoxBackGround.css({"width": "100%", "height": "100%"});
        });
    }

    function hide() {
        if (!isShown) {
            return;
        }
        options.beforeClose();
        divMsgBox.animate({ opacity: 0, "top": top - 50, "left": left }, 200);
        divMsgBoxBackGround.fadeOut(300);
        setTimeout(function () { divMsgBox.remove(); divMsgBoxBackGround.remove(); }, 300);
        setTimeout(options.afterClose, 300);
        $(window).unbind("resize");
        isShown = false;
    }

    function getDocHeight() {
        var D = document;
        return Math.max(
        Math.max(D.body.scrollHeight, D.documentElement.scrollHeight),
        Math.max(D.body.offsetHeight, D.documentElement.offsetHeight),
        Math.max(D.body.clientHeight, D.documentElement.clientHeight));
    }

    function getFocus() {
        divMsgBox.fadeOut(200).fadeIn(200);
    }

    $("#" + divMsgBoxButtonsId + " .btn").click(function (e) {
        hide();
    });

    divMsgBoxBackGround.click(function (e) {
        if ( options.modal )
            return;
        if (!options.showButtons || (options.showButtons && options.buttons.length<2) || options.autoClose) {
            hide();
        }
        else {
            getFocus();
        }
    });
};


function getFormData(form) {
    let formData = {};
    let data = [];
    let otherData = form.find('input, select, textarea').not('.hasInput input').serializeArray();
    form.find('.hasInput').each(function() {
        let obj = {};
        $(this).find('input').each(function() {
            let key = $(this).prop('name');
            let val = $(this).prop('value');
            obj[key] = val;
        });
        data.push(obj);
    });
    otherData.map(function(item) {
        let inputName = item.name;
        if (inputName.indexOf('[]') !== -1) {
            formData[inputName] = formData[inputName] ? [...formData[inputName], item.value] : [item.value];

        } else {
            formData[inputName] = item.value;
        }
    })
    formData['persons'] = data;
    return formData;
}

function ajaxlink($this, url) {

    if (typeof url == 'string') {
        $.ajax({
            url: url, //与此php页面沟通 
            beforeSend: function() {
                //禁用提交按钮，防止重复提交
                $this.attr('disabled', true);
                return true;
            },
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                alert(XMLHttpRequest.readyState + XMLHttpRequest.status + XMLHttpRequest.responseText);
            },
            success: function(data) {
                console.log(data);
                if (data.status === 1) {
                    type = "success";
                } else {
                    type = "error";
                    $.msgBox({
                        title: "提示",
                        content: data.info,
                        button: [
                            {
                                value: '确定',
                                className: 'cancel'
                            }
                        ],
                        afterClose: function () {
                            if (form.data('confirm-cb') && typeof window[form.data('confirm-cb')]=='function') {
                                window[form.data('confirm-cb')](data);
                            }
                            if(data.url.length > 0){
                                window.location = data.url;
                            }
                        }
                    });
                }
                if (type === 'success') {
                    //成功则跳转到返回的网址
                    setTimeout(function() {
                        window.location = data.url;
                    }, 300);
                } else {
                    $this.attr('disabled', false);
                }
            }
        });
    }
}
jQuery(document).ready(function($) {
    //ajax提交form
    $('body').on('submit', '.ajax-form', function(e) {
        e.preventDefault();
        var formValues = $(this).serialize();
        var form = $(this);
        var needDealData = form.data('needDealData');;
        $.ajax({
            url: form.attr('action') ? $(this).attr('action') : document.URL,
            type: form.attr('method'),
            data: needDealData === 1 ? getFormData(form) : formValues,
            beforeSend: function(e) {
                //禁用提交按钮，防止重复提交
                form.find(":submit").attr("disabled", true);
                return true;
            },
            success: function(data) {
                //成功状态，下面的是服务器返回的，数据库操作的状态
                if (data.status === 1) {
                    //返回成功信息的处理
                    //有提示信息，应该先显示提示信息，再跳转url
                    if(data.info){
                        if(data.url){
                            $.msgBox({
                                title: "提示",
                                content: data.info,
                                afterClose: function () {
                                    if (form.data('confirm-cb') && typeof window[form.data('confirm-cb')]=='function') {
                                        window[form.data('confirm-cb')](data);
                                    }
                                    window.location = data.url; 
                                },
                            });
                        }
                        else{
                            $.msgBox({
                                title: "提示",
                                content: data.info,
                                afterClose: function () {
                                    if (form.data('error-cb') && typeof window[form.data('error-cb')]=='function') {
                                        window[form.data('error-cb')](data);
                                    }
                                    window.location.reload();
                                },
                            });
                        }
                    }
                    //无提示信息，有跳转url，则直接跳转
                    else if(data.url){
                        window.location = data.url;
                    }
                    form.find(":submit").attr("disabled", false);
                } else {
                    $.msgBox({
                        title: "提示",
                        content: data.info,
                        button: [
                            {
                                value: '确定',
                                className: 'cancel'
                            }
                        ],
                        afterClose: function () {
                            if (form.data('confirm-cb') && typeof window[form.data('confirm-cb')]=='function') {
                                window[form.data('confirm-cb')](data);
                            }
                        }
                    });
                    form.find(":submit").attr("disabled", false);
                }
            },
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                $.msgBox({
                    title: "提示",
                    content: $(XMLHttpRequest.responseText).find('h1').text(),
                });
                form.find(":submit").attr("disabled", false);
            },
        });
    });
    $('body').on('submit', '.ajax-form2', function(e) {
        e.preventDefault();
        var formValues = $(this).serialize();
        var form = $(this);
        var needDealData = form.data('needDealData');;
        $.ajax({
            url: form.attr('action') ? $(this).attr('action') : document.URL,
            type: form.attr('method'),
            data: needDealData === 1 ? getFormData(form) : formValues,
            beforeSend: function(e) {
                //禁用提交按钮，防止重复提交
                form.find(":submit").attr("disabled", true);
                return true;
            },
            success: function(data) {
                //成功状态，下面的是服务器返回的，数据库操作的状态
                if (data.status === 1) {
                    //返回成功信息的处理
                    //有提示信息，应该先显示提示信息，再跳转url
                    if(data.info){
                        if(data.url){
                            window.location = data.url;
                        }
                        else{
                            $.msgBox({
                                title: "提示",
                                content: data.info,
                                afterClose: function () {
                                    if (form.data('error-cb') && typeof window[form.data('error-cb')]=='function') {
                                        window[form.data('error-cb')](data);
                                    }
                                    window.location.reload();
                                },
                            });
                        }
                    }
                    //无提示信息，有跳转url，则直接跳转
                    else if(data.url){
                        window.location = data.url;
                    }
                    form.find(":submit").attr("disabled", false);
                } else {
                    $.msgBox({
                        title: "提示",
                        content: data.info,
                        button: [
                            {
                                value: '确定',
                                className: 'cancel'
                            }
                        ],
                        afterClose: function () {
                            if (form.data('confirm-cb') && typeof window[form.data('confirm-cb')]=='function') {
                                window[form.data('confirm-cb')](data);
                            }
                        }
                    });
                    form.find(":submit").attr("disabled", false);
                }
            },
            error: function(XMLHttpRequest, textStatus, errorThrown) {
                $.msgBox({
                    title: "提示",
                    content: $(XMLHttpRequest.responseText).find('h1').text(),
                });
                form.find(":submit").attr("disabled", false);
            },
        });
    });
    // 上传文件
    $('.about_file_container').each(function() {
        var that = this;
        var uploadType = $(that).data('type');
        var ifMulti = $(that).data('multi') === 1 ? true : false; 
        var imgFormat = $(that).data('showType') === 'image' ? true : false;
        new plupload.Uploader({
            runtimes : 'html5,html4',
            browse_button : $(that).children('.upload-file-btn').get(0),
            multi_selection: ifMulti,
            container: $(that).get(0),
            url : 'http://oss.aliyuncs.com',
            filters: imgFormat ? {
                mime_types: [
                    {
                        title: '图片',
                        extensions: 'jpg,png,jpeg'
                    }
                ]
            } : {},
            init: {
                PostInit: function() {
                    $(that).children('.uploadify-queue').html('');
                },

                FilesAdded: function(up, files) {
                    plupload.each(files, function(file) {
                        var html = '<div id="' + file.id + '" class="uploadify-queue-item">' +
                                '<div class="uploadify-progress" lastloaded="0">' +
                                '<div class="uploadify-progress-bar" style="width: 0%;">' +
                                '</div>' +
                                '</div>' +
                                '<span class="up_percent">0%</span>' +
                                '<span class="up_filename">' + file.name + '</span>' +
                                '</div>';
                                $(that).children('.uploadify-queue').html(html);
                        set_upload_param(up, file.name, false, window.location.protocol + '//' + window.location.host + "/extends/AliyunOss/policyGet?type=" + uploadType,'title='+encodeURIComponent(file.name));
                    });
                },

                UploadProgress: function(up, file) {
                    $('#' + file.id).children('.uploadify-progress').attr('lastloaded', file.loaded);
                    $('#' + file.id).find('.uploadify-progress-bar').css('width', file.percent + "%");
                    $('#' + file.id).children('.up_percent').html(file.percent + "%");
                },

                FileUploaded: function(up, file, info) {
                    if (info.status == 200)
                    {
                        var response = JSON.parse(info.response);
                        if (response.err_msg) {
                            $(that).children('.uploadify-queue').empty();
                            $.msgBox({
                                title: '提示',
                                content: response.err_msg,
                            })
                            return;
                        }
                        var file_div = '<div class="list-group-item file-item" data-id="'+response.file_id+'"><a href="'+ response.file_url+'" target="_blank">' + file.name +'</a>' +
                        '  <i class="iconfont icon-close-o remove-file"></i></div>';
                        var img_div = '<div class="list-group-item file-item" data-id="'+response.file_id+'"><img src="'+ response.file_url+'" alt="' + file.name + '" />' +
                        '  <i class="iconfont icon-close-o remove-file"></i></div>';
                        var new_file = imgFormat ? img_div : file_div;
                        ifMulti ? $(that).children('.file_container').append(new_file) : $(that).children('.file_container').html(new_file);
                        let oldIds = [];
                        // 第一次上传为空的情况
                        if($(that).children('input').prop('value')!=''){
                            oldIds = $(that).children('input').prop('value').split(',');
                        }
                        let addId = response.file_id;
                        oldIds.push(addId);
                        $(that).children('input').attr('value', ifMulti ? oldIds.join(',') : addId);
                    }
                    else
                    {
                        $.msgBox({
                            title: '提示',
                            content: info.response,
                        })
                    }
                    $(that).children('.uploadify-queue').empty();
                },

                Error: function(up, err) {
                    var MAX_SIZE_ALLOWED = '';
                    var errText = '';
                    var codeMap = {
                        EntityTooLarge: -600,
                    }
                    try{
                        var parser = new DOMParser();
                        xmlDoc = parser.parseFromString(err.response, "text/xml");
                        errText = $(xmlDoc).find('Code').text();
                        MAX_SIZE_ALLOWED = ($(xmlDoc).find('MaxSizeAllowed').text() / 1024 / 1024) + 'Mb';
                    }catch(e){
                    }

                    err.code = errText ? codeMap[errText] : err.code;

                    $('#' + err.file.id).remove();

                    if (err.code == codeMap.EntityTooLarge) {
                        $.msgBox({
                            title: '提示',
                            content: "选择的文件太大了,建议不超过"+ MAX_SIZE_ALLOWED +",请重新上传",
                        })
                    }
                    else if (err.code == -601) {
                        $.msgBox({
                            title: '提示',
                            content: "选择的文件后缀不对,建议上传"+ fileExts +",请重新上传",
                        })
                    }
                    else if (err.code == -602) {
                        $.msgBox({
                            title: '提示',
                            content: "这个文件已经上传过一遍了",
                        })
                    }
                    else
                    {
                        $.msgBox({
                            title: '提示',
                            content: err.response,
                        })
                    }
                }
            }
        }).init();

    })

    // 删除上传的文件
    $('body').on('click', '.about_file_container .file_container .remove-file', function () {
        var ready_for_remove_id = $(this).closest('.file-item').attr('data-id'); 
        var deleteBeforeArr =$(this).parents('.file_container').siblings('input').val().split(',');
        deleteBeforeArr = deleteBeforeArr.filter(function(item) {
            return item !== ready_for_remove_id;
        })
        $(this).parents('.file_container').siblings('input').val(deleteBeforeArr.join(','));//删除后覆盖原input的值为空

        $(this).closest('.file-item').remove(); 
    });

    // 点击按钮请求
    $('.ajax-link').on('click', function(){
        var url = $(this).data('url');
        ajaxlink($(this), url);
    });
});

